export default "data:video/mp2t;base64,aW1wb3J0IENpcmN1bGFyU3Bpbm5lciBmcm9tICcuL0NpcmN1bGFyU3Bpbm5lci52dWUnOwoKZXhwb3J0IHsgQ2lyY3VsYXJTcGlubmVyIH07IA=="